// @flow
import React, { type Node } from 'react';
import classnames from 'classnames';

type ImagePlaceholderProps = {
  aspectRatio: number,
  children: Node,
  className?: string,
};

export function ImagePlaceholder({ aspectRatio = 0, children, className }: ImagePlaceholderProps) {
  return (
    <span className={classnames(className, 'block')}>
      <span className="block h-0 relative w-full" style={{ paddingBottom: `${aspectRatio}%` }}>
        <span className="absolute inset-0">{children}</span>
      </span>
    </span>
  );
}
